/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgBulkOperation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 16 16"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.435 5.588a.5.5 0 0 0 0-.859L8.295 1.07a.5.5 0 0 0-.511 0l-6.14 3.66a.5.5 0 0 0 0 .858l6.14 3.659a.5.5 0 0 0 .512 0l6.14-3.659Zm-11.558-.43L8.04 2.083l5.163 3.077L8.04 8.235 2.877 5.16Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.61 8.07s-.053.02-.174.092l-6.14 3.722a.5.5 0 0 1-.512 0l-6.14-3.722-.173-.107V6.883s.584.36.686.42L8.04 10.81l5.884-3.506c.124-.074.685-.416.685-.416v1.184Z"
    />
    <path
      fill="currentColor"
      d="M14.61 10.774s-.05.024-.174.098l-6.14 3.722a.5.5 0 0 1-.512 0l-6.14-3.722c-.118-.07-.173-.1-.173-.1V9.604l.686.408 5.883 3.569 5.884-3.569c.128-.076.685-.447.685-.447v1.208Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M14.435 5.588a.5.5 0 0 0 0-.859L8.295 1.07a.5.5 0 0 0-.511 0l-6.14 3.66a.5.5 0 0 0 0 .858l6.14 3.659a.5.5 0 0 0 .512 0l6.14-3.659Zm-11.558-.43L8.04 2.083l5.163 3.077L8.04 8.235 2.877 5.16Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M14.61 8.07s-.053.02-.174.092l-6.14 3.722a.5.5 0 0 1-.512 0l-6.14-3.722-.173-.107V6.883s.584.36.686.42L8.04 10.81l5.884-3.506c.124-.074.685-.416.685-.416v1.184Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M14.61 10.774s-.05.024-.174.098l-6.14 3.722a.5.5 0 0 1-.512 0l-6.14-3.722c-.118-.07-.173-.1-.173-.1V9.604l.686.408 5.883 3.569 5.884-3.569c.128-.076.685-.447.685-.447v1.208Z"
    />
  </svg>
)
const Memo = memo(SvgBulkOperation)
export default Memo
